module.exports = __webpack_public_path__ + "img/brand--sunat.402b7826.svg";